import type {
  ShopifyAdminQueryQueryResponse,
  ShopifyAdminQueryQueryVariables,
} from '~/api/graphql/queries/shopifyAdminQuery.generated';

import { ShopifyAdminQueryDocument } from '~/api/graphql/queries/shopifyAdminQuery.generated';
import { appFetcher } from './gatewayClient';

/**
 * Runs a Shopify Admin document through the gateway's `shopifyAdminQuery` proxy, which forwards it
 * to Shopify under the shop's own access token. Mirrors `appFetcher`'s signature, so a call site
 * reading a platform listing swaps one for the other.
 *
 * Only query operations get through, and the gateway bounds the document — depth, total selections
 * and the records a single path may ask for. Shopify's own errors, throttling included, surface as
 * the request's errors rather than being retried there.
 */
export const shopifyAdminFetcher =
  <TData, TVariables>(document: string, variables?: TVariables) =>
  async (): Promise<TData> => {
    const response = await appFetcher<
      ShopifyAdminQueryQueryResponse,
      ShopifyAdminQueryQueryVariables
    >(ShopifyAdminQueryDocument, { query: document, variables })();

    // `Map` is an untyped scalar, so the gateway reports the payload as `any`. What it holds is
    // exactly what the passed document selects, which is the type the caller names.
    return response.shopifyAdminQuery as TData;
  };
